import { ReactNode, useEffect, useState } from 'react';

import { proxy } from 'valtio';

import { useSnapshot } from 'hooks/use-safe-snapshot';

export enum DatasheetMode {
    VIEW = 'view',
    EDIT = 'edit',
    CREATE = 'create',
    DUPLICATE = 'duplicate',
    BULK = 'bulk',
}

const modeState = proxy({
    mode: DatasheetMode.VIEW,
});

export function DatasheetModeWrapper({
    children,
    initialMode = DatasheetMode.VIEW,
}: {
    children: ReactNode;
    initialMode?: DatasheetMode;
}) {
    return <InitializeDatasheetMode initialMode={initialMode}>{children}</InitializeDatasheetMode>;
}

const InitializeDatasheetMode = ({ initialMode, children }: { initialMode: DatasheetMode; children: ReactNode }) => {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        modeState.mode = initialMode;
        setInitialized(true);
    }, [initialMode]);

    return initialized ? <>{children}</> : null;
};

export const useDatasheetMode = () => {
    const { mode } = useSnapshot(modeState);

    return mode;
};

export const useDatasheetModeState = () => {
    const { mode } = useSnapshot(modeState);

    const setMode = (mode: DatasheetMode) => {
        modeState.mode = mode;
    };

    return [mode, setMode] as [DatasheetMode, (mode: DatasheetMode) => void];
};
